import { WorkspaceAsyncJobsAdapter } from '@xometry/workspace';
import useAsyncJobStatus from 'utils/hooks/useAsyncJobStatus';

/** Polls the ERP job endpoint for `async: true` bulk actions. */
export const erpAsyncJobsAdapter: WorkspaceAsyncJobsAdapter = {
  useJobStatus: ({ onCompleted }) => {
    const [startPolling, loading] = useAsyncJobStatus({ onCompleted: (status) => onCompleted(status) });

    return { startPolling, loading };
  },
};
